import ReactDOM from "react-dom/client";
import Scene from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<Scene />);
